import {Component, Input} from '@angular/core';
import {UserService} from '../../../../services/user.service';

@Component({
  template: `
    <mat-card>
      <orders-section [orders]="orders" (getOrd)="getOrders($event)" [disableSearch]="true"></orders-section>
    </mat-card>
    `,
  selector: 'orders'
})

export class OrdersComponent {
  orders: Array<any>;
  userId: any;
  displayedColumns = ['status', 'order_number', 'created_at', 'consignor', 'consignee', 'amount'];
  constructor(private userService: UserService) {}

  ngOnInit() {
    this.userService.userId.subscribe(id => {
      this.userId = id;
    });

  }

  getOrders({page, pageSize}) {
    this.userService.getUserOrders(this.userId, page, pageSize)
      .subscribe(data => {
        this.orders = data;


        // orderRef: resp.data[key].order_number,
        //   amount: resp.data[key].amount,
        //   extra_charge: resp.data[key].extra_charge,
        //   extra_charge_failed: resp.data[key].extra_charge_failed,
        //   created: resp.data[key].created_at,
        //   billingAddress: resp.data[key].billing_address,
        //   canceled_at: resp.data[key].canceled_at == null ? false : true,
        //   order_id: resp.data[key].id,
        //   icon: this.find(resp.data[key].status).icon,
        //   status: this.find(resp.data[key].status).label,
        //   order-shipments: resp.data[key].order-shipments,
        //   delivery_address: ( resp.data[key].order-shipments.length > 0 ?
        //   (resp.data[key].order-shipments[0].delivery_address == null ?
        //     'null' : resp.data[key].order-shipments[0].delivery_address.address ) : 'null' ),
        //   pickup_address: ( resp.data[key].order-shipments.length > 0 ?
        //   (resp.data[key].order-shipments[0].pickup_address == null ?
        //     'null' : resp.data[key].order-shipments[0].pickup_address.address ) : 'null' )



      });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/users/components/orders/orders.component.ts